module.exports = __webpack_public_path__ + "static/media/fuelPin.e32054f4.png";